import { render, staticRenderFns } from "./SegmentationRow.vue?vue&type=template&id=0d0cae0f&scoped=true&"
import script from "./SegmentationRow.vue?vue&type=script&lang=js&"
export * from "./SegmentationRow.vue?vue&type=script&lang=js&"
import style0 from "./SegmentationRow.vue?vue&type=style&index=0&id=0d0cae0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cae0f",
  null
  
)

export default component.exports